import { Address } from '@tokeet-frontend/tv3-platform'

export enum VendorType {
  Cleaning = 'cleaning',
  Maintenance = 'maintenance',
  Laundry = 'laundry',
  Management = 'management',
  Security = 'security',
}

export interface VendorResponse {
  pkey: string
  account: number
  type: VendorType
  name: string
  email: string
  phone: string
  whatsapp_number: string
  address: Address
  language?: string

  created: number
  updated: number
  archived: number
}

export type CreateVendorPayload = Omit<VendorResponse, 'pkey' | 'account' | 'created' | 'updated'>

export type UpdateVendorPayload = Partial<CreateVendorPayload>
